import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../context/AuthContext";
import { useNotificationsStore } from "../../store/Notifications/NotificationsStore";
import sxNetApi from "../../api/sxNetConnector";
import { useBase64 } from "../useBase64";
import { useNotificationDetailsStore } from "../../store/Notifications/NotificationDetailsStore";
import { set } from "date-fns";

export const useFetchNotifications = () => {

    const { user, resources } = useContext(AuthContext);
    const [isNotificationsLoading, setIsNotificationsLoading] = useState(false)
    

    const assingGetNotitficationsError = useNotificationsStore(state => state.assingGetNotificationsError);
    const lastNotificationId = useNotificationsStore(store => store.lastNotificationId);
    const mergeNotifications = useNotificationsStore(store => store.mergeNotifications)
    const mergeNotificationDetails = useNotificationDetailsStore(store => store.mergeNotificationDetails)
    const notifications = useNotificationsStore(store => store.notifications);

    const { utf8ToBase64 } = useBase64();

    const updateNotifications = async () => {
        setIsNotificationsLoading(true);
        if (notifications.length > 0 && !lastNotificationId) return;
        if (!user?.user_id) return;

        // Encriptar los valores
        const encodedUserId = utf8ToBase64(user.user_id.toString());
        const encodedLastNotificationId = utf8ToBase64(lastNotificationId.toString());

        // Construir la URL con los valores encriptados
        const url = `/notifications/createprojecttasknotificationsandgetnewnotifications/${encodedUserId}/${encodedLastNotificationId}`;

        try {
            let resourceId = (url.indexOf("/", 1) === -1) ? (url.indexOf("?") === -1) ? url : url.substring(0, url.indexOf('?', 1)) : url.substring(0, url.indexOf('/', 1));
            const response = await sxNetApi.post(url, null, {
                headers: {
                    'UserId': user?.user_id,
                    'Password': user?.password,
                    'GroupId': user?.group_id,
                    'ResourceId': resources?.get(resourceId),
                    'Authorization': `Bearer ${localStorage.getItem("token")}`,
                }
            });
            if (response.data.notifications.length === 0) return;

            mergeNotifications(response.data.notifications);
            mergeNotificationDetails(response.data.notificationDetails)
            assingGetNotitficationsError(null);
        } catch (error) {
            assingGetNotitficationsError("Error al traer las notificaciones");
        } finally {
            setIsNotificationsLoading(false);
        }
    };


    return {
        updateNotifications,
        isNotificationsLoading
    }
}